module.exports = __webpack_public_path__ + "assets/55945ba271ac248f4b3872b42b5fd026.mp3";